export const config = {
  testQueryParam: 'tracktest',
  ga: {
    script: '//www.paypalobjects.com/gajs/analytics.js',
    id: {
      prod: {
        stock: 'UA-37159521-1',
        exp: 'UA-37159521-8',
      },
      dev: {
        stock: 'UA-37159521-2',
        exp: 'UA-37159521-7',
      },
    },
  },
  fpti: {
    script: {
      prod: 'https://www.paypalobjects.com/pa/js/min/pa.js',
      dev: 'https://www.paypalobjects.com/staging/pa/js/min/pa.js',
    },
    id: 'PayPalAnalytics',
    // Colon-delimited fields for constructing fpti.pgrp & fpti:page -- FPTI format:
    // website:feature:sub_feature1:sub_feature2:content_or_task:user_type:flavor:test_variant
    pageSlugs: ['developer'],
  },
}
